import * as React from 'react';
import { useTheme } from '@xstyled/styled-components';

function ChevronUp (props) {
    const theme = useTheme();
    const { languageSelectorChevron } = theme.colors;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            fill="none"
            {...props}
        >
            <g clipPath="url(#a)">
                <path
                    fill={languageSelectorChevron}
                    fillRule="evenodd"
                    d="M14.77 12.79a.75.75 0 0 1-1.06-.02L10 8.832 6.29 12.77a.75.75 0 1 1-1.08-1.04l4.25-4.5a.75.75 0 0 1 1.08 0l4.25 4.5a.75.75 0 0 1-.02 1.06Z"
                    clipRule="evenodd"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path
                        fill="#fff"
                        d="M0 0h20v20H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export default ChevronUp;
